<script setup lang="ts"></script>

<template>
  <div class="dialog-footer">
    <slot></slot>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  .dialog-footer {
    @apply absolute inset-x-0 bottom-0 flex items-center justify-end px-6 py-4 gap-x-4;
  }
</style>
